import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';

import { useStyles } from './styles';

function Logo (props) {
    const {
        widget = {},
        commonUIStyles,
    } = props;
 
    const classes = useStyles({
        widget,
        commonUIStyles,
    });

    return (
        <Grid className={classNames(['ecal-header-logo', classes.logoSpace])}>
            <img 
                alt='ecal-publishers-logo'
                className={classes.logo} 
                src={widget.logo}
            />
        </Grid>
    );
}

Logo.propTypes = {
    widget: PropTypes.any,
};

export default Logo;